module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "histroy-wrapper"
  }, [_c('loading', {
    attrs: {
      "ifLoadingStart": _vm.isLoading
    }
  }), _vm._v(" "), (!_vm.isLoading) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.histroyList,
      "row-key": "version_id",
      "expand-row-keys": _vm.expandRow
    },
    on: {
      "row-click": _vm.toggleExpansion
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand",
      "expand-change": _vm.onExpandChange
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return _c('div', {
          staticClass: "desc-infor-wrapper"
        }, [(row.app_basic !== '') ? _c('div', {
          staticClass: "desc-left"
        }, [_c('h4', {
          staticClass: "title"
        }, [_vm._v("作品信息")]), _vm._v(" "), (row.app_basic.language.length) ? _c('p', {
          staticClass: "specific-desc"
        }, [_c('span', {
          staticClass: "desc-title"
        }, [_vm._v("开发语言：")]), _vm._v(" "), _c('span', {
          staticClass: "desc-text"
        }, [_vm._v("\n                            " + _vm._s(row.app_basic.language.join()) + "\n                        ")])]) : _vm._e(), _vm._v(" "), (row.app_basic.sys_type !== '脚本工具' && row.app_basic.browser.length) ? _c('p', {
          staticClass: "specific-desc"
        }, [_c('span', {
          staticClass: "desc-title"
        }, [_vm._v("浏览器兼容：")]), _vm._v(" "), _c('span', {
          staticClass: "desc-text"
        }, [_vm._v(_vm._s(row.app_basic.browser.join()))])]) : _vm._e(), _vm._v(" "), (row.app_basic.deploy.length) ? _c('p', {
          staticClass: "specific-desc"
        }, [_c('span', {
          staticClass: "desc-title"
        }, [_vm._v("部署环境：")]), _vm._v(" "), _c('span', {
          staticClass: "desc-text"
        }, [_vm._v(_vm._s(row.app_basic.deploy.join()))])]) : _vm._e(), _vm._v(" "), (row.app_basic.i18n.length) ? _c('p', {
          staticClass: "specific-desc"
        }, [_c('span', {
          staticClass: "desc-title"
        }, [_vm._v("语言支持：")]), _vm._v(" "), _c('span', {
          staticClass: "desc-text"
        }, [_vm._v(_vm._s(row.app_basic.i18n.join()))])]) : _vm._e(), _vm._v(" "), (row.app_basic.labels.length) ? _c('p', {
          staticClass: "specific-desc"
        }, [_c('span', {
          staticClass: "desc-title"
        }, [_vm._v("关联标签：")]), _vm._v(" "), _c('span', {
          staticClass: "desc-text"
        }, [_vm._v(_vm._s(row.app_basic.labels.join()))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
          class: ['desc-right', {
            'add-border': row.app_basic !== ''
          }]
        }, [_c('h4', {
          staticClass: "title"
        }, [_vm._v("更新内容")]), _vm._v(" "), _c('pre', {
          staticClass: "text",
          domProps: {
            "innerHTML": _vm._s(_vm.filterXSS(row.update_content))
          }
        })])])
      }
    }], null, false, 3787734149)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "版本号",
      "prop": "update_version"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return _c('div', {
          staticClass: "title-item"
        }, [_c('span', [_vm._v(_vm._s(props.row.update_version))]), _vm._v(" "), (props.row.isNew) ? _c('span', {
          staticClass: "new"
        }, [_vm._v("new")]) : _vm._e()])
      }
    }], null, false, 950277638)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "依赖蓝鲸版本",
      "prop": "bk_version"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(props.row.bk_version || '--'))])]
      }
    }], null, false, 2690200906)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发布时间",
      "prop": "update_time",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "大小",
      "prop": "file_size"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', [_vm._v(_vm._s(props.row.file_size || '--'))])]
      }
    }], null, false, 3940569562)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "MD5",
      "prop": "file_md5",
      "width": 360
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return _c('div', {
          staticClass: "file-md5"
        }, [_c('span', [_vm._v(_vm._s(row.file_md5))]), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "复制",
            "placement": "top"
          }
        }, [_c('span', {
          staticClass: "copy-icon",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.handleCopy(row.file_md5)
            }
          }
        })])], 1)
      }
    }], null, false, 1826517072)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "prop": "id"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return _c('div', {}, [_c('p', {
          class: ['text', {
            'disabled': props.row.version_id === '' || props.row.version_id === 0
          }],
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.download(props.row, props.$index)
            }
          }
        }, [_c('i', {
          staticClass: "icon-xiazai"
        }), _vm._v("下载\n                ")])])
      }
    }], null, false, 464756401)
  })], 1) : _vm._e(), _vm._v(" "), _c('v-alert', {
    attrs: {
      "options": _vm.options
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-0feeadef!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/application/histroy.vue
// module id = l8if
// module chunks = 15